import { render, staticRenderFns } from "./SingleDish.vue?vue&type=template&id=fb955e9a&scoped=true&"
import script from "./SingleDish.vue?vue&type=script&lang=js&"
export * from "./SingleDish.vue?vue&type=script&lang=js&"
import style0 from "./SingleDish.vue?vue&type=style&index=0&id=fb955e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb955e9a",
  null
  
)

component.options.__file = "SingleDish.vue"
export default component.exports